module.exports = __webpack_public_path__ + "media/assets/icons/checkmark/checkmark-fill-687d36c813746f551243cafd58a4aa3c.svg";